import { render, staticRenderFns } from "./widget-store.vue?vue&type=template&id=541b3d7a&scoped=true&"
import script from "./widget-store.vue?vue&type=script&lang=js&"
export * from "./widget-store.vue?vue&type=script&lang=js&"
import style0 from "./widget-store.vue?vue&type=style&index=0&id=541b3d7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541b3d7a",
  null
  
)

export default component.exports